module.exports = __webpack_public_path__ + "static/gravata-f799d449db37422fabd02fe40a74257c.jpg";